import React from "react"
import classNames from "utils/classNames"

type ElementProps = {
  className?: string
  children: React.ReactNode
}
const DataCell = ({ className, children }: ElementProps) => {
  return (
    <span className={classNames(className, "vt-data-cell")}>{children}</span>
  )
}

const Title = ({ children, className }: ElementProps) => {
  return <div className={classNames("vt-title", className)}>{children}</div>
}

const Subtitle = ({ children, className }: ElementProps) => {
  return <div className={classNames("vt-subtitle", className)}>{children}</div>
}
export default DataCell
export { Title, Subtitle }
